import { fontSizes } from '../../constants/constants';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ViewItems from '../../components/ViewItems';
import WathqVerificationFunctional from './index.function';
import AuthWrapper from '../../components/AuthWrapper';
import { Formik } from 'formik';
import images from '../../constants/images';
import { ReactSVG } from 'react-svg';
import { cn } from '../../utils/utils';
import icons from '../../constants/icons';
import {
  nafath_verification_schema,
  nafath_verification_validation_schema,
  wathq_verification_schema,
  wathq_verification_validation_schema,
} from '../../validations_schemas/wathq_verification_schema';
import ErrorText from '../../components/ErrorText';
import CustomInput from '../../components/CustomInput';
import { NafathModal } from './components';

const WathqVerification = () => {
  const {
    TextWeight,
    authLoading,
    getContentKey,
    isArabic,
    navigate,
    isNafathVarified,
    showModal,
    closeModal,
    handleNafathVerification,
    handleSubmit,
    nafath_code,
    doneRef,
  } = WathqVerificationFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />
        <img src={images.textLogo} width={70} className='mt-10' />

        <Formik
          validationSchema={isNafathVarified ? wathq_verification_validation_schema : nafath_verification_validation_schema}
          initialValues={isNafathVarified ? wathq_verification_schema : nafath_verification_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values) => (isNafathVarified ? handleSubmit(values) : handleNafathVerification(values))}
          className='w-full'
        >
          {({ handleSubmit, setFieldValue, setFieldError, values, errors }) => {
            return (
              <>
                <Text
                  text={getContentKey(isNafathVarified ? 'heading' : 'nafath_verification')}
                  weight={TextWeight.semiBold}
                  size={fontSizes.h18}
                  className={'mb-5 mt-10'}
                />

                {isNafathVarified ? (
                  <>
                    <CustomInput
                      label={getContentKey('crNumber')}
                      value={values?.crNumber}
                      isRequired={true}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setFieldValue('crNumber', e.target.value);
                          setFieldError('crNumber', '');
                        }
                      }}
                      placeholder={getContentKey('placeholder_crNumber')}
                      divClasses={'mt-5'}
                      maxLength={10}
                    />
                    <ErrorText text={getContentKey(errors?.crNumber ?? '')} />

                    <CustomInput
                      label={getContentKey('unified_national_no')}
                      value={values?.unifiedNo}
                      isRequired={true}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setFieldValue('unifiedNo', e.target.value);
                          setFieldError('unifiedNo', '');
                        }
                      }}
                      placeholder={getContentKey('enter_unified_no')}
                      divClasses={'mt-3'}
                      maxLength={10}
                    />
                    <ErrorText text={getContentKey(errors?.unifiedNo ?? '')} />
                  </>
                ) : (
                  <>
                    <CustomInput
                      label={getContentKey('national_id_iqama')}
                      value={values?.number}
                      isRequired={true}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setFieldValue('number', e.target.value);
                          setFieldError('number', '');
                        }
                      }}
                      placeholder={getContentKey('national_id_iqama')}
                      divClasses={'mt-5'}
                      maxLength={10}
                    />
                    <ErrorText text={getContentKey(errors?.number ?? '')} />
                  </>
                )}
                {/* 
                <CustomInput
                  isRequired={true}
                  label={getContentKey('crNumber')}
                  value={values?.crNumber}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) {
                      setFieldValue('crNumber', e.target.value);
                    }
                  }}
                  placeholder={getContentKey('placeholder_crNumber')}
                  divClasses={'mt-5'}
                  maxLength={10}
                /> */}

                <ViewItems className={'w-full gap-1 mt-4'}>
                  <Button
                    text={getContentKey('proceed_btn')}
                    className={'mt-6 my-2 w-full'}
                    onClick={handleSubmit}
                    loading={authLoading}
                    isDisabled={isNafathVarified && !wathq_verification_validation_schema.isValidSync(values)}
                    type={'submit'}
                  />
                </ViewItems>

                <NafathModal
                  open={showModal}
                  onClose={closeModal}
                  nafath_code={nafath_code}
                  onTryAgain={() => {
                    doneRef.current = false;
                    handleNafathVerification(values);
                  }}
                />
              </>
            );
          }}
        </Formik>
      </ViewItems>
    </AuthWrapper>
  );
};

export default WathqVerification;
